import { render } from "./Overview.vue?vue&type=template&id=7b64ec46&bindings={\"classroom\":\"props\",\"flash\":\"props\",\"errors\":\"props\",\"posts\":\"props\",\"authUser\":\"props\",\"selectedRecord\":\"data\",\"form\":\"data\",\"postMessage\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"confirmDelete\":\"options\"}"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7b64ec46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b64ec46')) {
    api.reload('7b64ec46', script)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=7b64ec46&bindings={\"classroom\":\"props\",\"flash\":\"props\",\"errors\":\"props\",\"posts\":\"props\",\"authUser\":\"props\",\"selectedRecord\":\"data\",\"form\":\"data\",\"postMessage\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"confirmDelete\":\"options\"}", () => {
    api.rerender('7b64ec46', render)
  })

}

script.__file = "resources/js/Pages/AssignedClassrooms/Classroom/Overview.vue"

export default script